import { useMutation, useQuery } from "@tanstack/react-query";
import { AxiosResponse } from "axios";
import { Store } from "sunflower-antd";
import { httpClient, ROOT_URL } from "../App";

export const useCreateCompany = (config = {}) => {
  return useMutation({
    ...config,
    mutationFn: createCompany,
  });
};

export function createCompany(company: any): Promise<AxiosResponse<any>> {
  return httpClient.post(`${ROOT_URL}/api/v1/companies/create`, company);
}

export const useCreateRemitter = (config = {}) => {
  return useMutation({
    ...config,
    mutationFn: createRemitter,
  });
};

export function createRemitter(company: any): Promise<AxiosResponse<any>> {
  return httpClient.post(
    `${ROOT_URL}/api/v1/companies/createRemitter`,
    company
  );
}

export const useGetListCompany = (params: {
  start: number;
  end: number;
  name?: string;
  country?: string;
  ignoreId?: string;
}) => {
  return useQuery<{
    data: {
      data: {
        total: number;
        page: number;
        pageSize: number;
        totalPages: number;
        items: [];
      };
    };
  }>(
    [
      `/api/v1/companies/get-list`,
      params.start,
      params.end,
      params.name,
      params.country,
      params.ignoreId,
    ],
    async () => getListCompany(params)
  );
};

export function getListCompany({
  start,
  end,
  name,
  country,
  ignoreId,
}: {
  start: number;
  end: number;
  name?: string;
  country?: string;
  ignoreId?: string;
}) {
  const params = new URLSearchParams();
  params.append("_start", String(start));
  params.append("_end", String(end));
  if (name) params.append("_like", name);
  if (country) params.append("_country", country);
  if (ignoreId) params.append("_ignoreId", ignoreId);
  return httpClient.get(
    `${ROOT_URL}/api/v1/companies/get-list?${params.toString()}`
  );
}

export const useGetDetailCompany = (id: number | null) => {
  return useQuery<{ data: any }>(
    [`/api/v1/companies/:id`, id],
    async () => getDetailCompany(id),
    {
      enabled: !!id,
    }
  );
};

export function getDetailCompany(id: number | null) {
  return httpClient.get(`${ROOT_URL}/api/v1/companies/${id}`);
}

export const useUpdateCompany = (config = {}) => {
  return useMutation({
    ...config,
    mutationFn: updateCompany,
  });
};

export function updateCompany(company: any) {
  return httpClient.patch(`${ROOT_URL}/api/v1/companies/update`, company);
}

export const useDeleteCompany = (config = {}) => {
  return useMutation({
    ...config,
    mutationFn: deleteCompany,
  });
};

export function deleteCompany(id: number | null) {
  return httpClient.delete(`${ROOT_URL}/api/v1/companies/delete/${id}`);
}

export const useGetCompanyDefault = (params: {
  currencyId: number | undefined;
  name?: string;
}) => {
  return useQuery<{ data: any }>(
    [`/api/v1/companies/defaults`, params?.currencyId, params?.name],
    async () => getCompanyDefault(params),
    {
      enabled: !!params?.currencyId,
    }
  );
};

export const useGetCompanyDefaultMutation = (config = {}) => {
  return useMutation({
    ...config,
    mutationFn: getCompanyDefault,
  });
};

export function getCompanyDefault(params: {
  currencyId: number | undefined;
  name?: string;
}) {
  const param = new URLSearchParams();
  if (params?.currencyId)
    param.append("currencyId", String(params?.currencyId));
  if (params.name) param.append("_like", params.name);
  return httpClient.get(
    `${ROOT_URL}/api/v1/companies/defaults?${param.toString()}`
  );
}
